function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.3 4.6c-1.2.1-2.1 1.2-2.2 2.5C2 8.2 2 9.5 2 10.3c0 .9 0 2.2.1 3.3.1 1.3 1 2.4 2.2 2.5 1.4.1 3.3.3 5.7.3 2.4 0 4.3-.1 5.7-.3 1.2-.1 2.1-1.2 2.2-2.5.1-1.2.1-2.5.1-3.3 0-.8 0-2.1-.1-3.2-.1-1.3-1-2.4-2.2-2.5-1.3-.1-3.3-.2-5.7-.2-2.4 0-4.3.1-5.7.2zm4.1 3.2 4.1 2.5-4.1 2.5v-5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgSocialYoutube;